/**
 * Limo Covers  limo-covers
 * RV Covers    rv-covers
 * Seat Covers	seat-covers
 *
 * Car Covers	car-covers
 * SUV Covers	suv-covers
 * Truck Covers	truck-covers
 * Van Covers	van-covers
 *
 * Boat Covers  boat-covers
 * Jet Ski Covers	jet-ski-covers
 * Bimini Tops	bimini-tops
 * Pontoon Covers	pontoon-covers
 *
 * Motorcycle Covers	motorcycle-covers
 * Scooter Covers	scooter-covers
 * ATV Covers	atv-covers
 * UTV Covers	utv-covers
 * Snowmobile Covers	snowmobile-covers
 */

const CATEGORIES= {
    // "limo-covers": { hasOptions: true },
    "rv-covers": { hasOptions: true },
    // "seat-covers": { hasOptions: true },
    "car-covers": { hasOptions: true },
    "suv-covers": { hasOptions: true },
    "truck-covers": { hasOptions: true },
    "van-covers": { hasOptions: true },

    "boat-covers": { hasOptions: true },
    "jet-ski-covers": { hasOptions: false },
    "bimini-tops": { hasOptions: true },
    "pontoon-covers": { hasOptions: false },

    "motorcycle-covers": { hasOptions: false },
    "scooter-covers": { hasOptions: false },
    "atv-covers": { hasOptions: false },
    "utv-covers": { hasOptions: false },
    "snowmobile-covers": { hasOptions: false },
};

exports.CATEGORIES = CATEGORIES;